/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { Title } from '@angular/platform-browser';
import { responseMessageStatus, ResponseStatus } from 'src/@shared/shared/enum';
import { supplierPortalURL } from 'src/environments/environment';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfigService } from 'src/@services/config.service';
import { SsoHandoffService } from 'src/@shared/auth';
import { ProfileMenuUser } from 'src/app/pages/common-layout/account-settings/profile-menu/profile-menu.component';

@Component({
  selector: 'app-switch-ac',
  templateUrl: './switch-ac.component.html',
  styleUrls: ['./switch-ac.component.scss'],
  standalone: false,
})
export class SwitchAcComponent implements OnInit {
  //#region properties
  isVisibleSwitchAccountModal = true;
  @Output() hideSwitchAccountModal = new EventEmitter();
  listOfAllocatedSites: object[] = [];
  listOfSupplierAllocatedSites: object[] = [];
  listOfSupplierBankAllocatedSites: object[] = [];
  isSiteSelected: boolean = false;
  BearerToken = localStorage.getItem('BearerToken');
  canAccessSummary: boolean = true;
  canAccessSupplierSummary: boolean = true;
  isDataLoaded: boolean = false;
  listOfAccounts: any[] = [];
  listOfSuppliers: any[] = [];
  listOfSupplierBanks: any[] = [];
  selectedAccount: any = null;
  selectedSupplier: any = null;
  selectedSupplierBank: any = null;
  listOfSites: any[] = [];
  isVisibleAccountFilter: boolean = false;
  isVisibleSupplierFilter: boolean = false;
  isVisibleSupplierBankFilter: boolean = false;
  searchText: string = '';
  selectedSiteDetails: any = JSON.parse(
    sessionStorage.getItem('SiteDetails') || '{}'
  );
  searchTextChanged = new Subject<string>();
  isSearch: boolean = false;
  noAccountsAssigned = false;
  NoSearchRecordFound: boolean = false;
  listOfSBSites: any[];
  isInternational: boolean = this._configService.isInternational();
  userInfo: ProfileMenuUser = JSON.parse(localStorage.getItem('UserInfo') || '{}');

  //#endregion

  //constructor
  constructor(
    @Inject(Router) public _router: Router,
    @Inject(Location) private location: Location,
    public _cs: CommonService,
    private _iS: InnerPagesService,
    private titleService: Title,
    private _configService: ConfigService,
    private ssoHandoff: SsoHandoffService
  ) {
    this.titleService.setTitle('Switch Account - PayBev');
  }

  //#region functions
  ngOnInit(): void {

    //to check whether site is selected or not
    const BearerToken = localStorage.getItem('BearerToken');

    if (BearerToken == null) {
      this._router.navigate(['/login']);
    } else {
      this.getUserSites(true);
      this.isSiteSelected =
        localStorage.getItem('IsSiteSelected') == 'true' ? true : false;

      this.searchTextChanged.pipe(
        debounceTime(500),
        switchMap((text: string) => {
          this.isDataLoaded = true;
          this.isSearch = text?.length >= 3 ? true : false;
          return this._iS.getUserAccountsSites(text);
        })
      ).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (typeof (response.result) == 'string') {
            // this._cs.displayMessage(responseMessageStatus.error, response.result);
            // this.listOfAccounts = [];
            // this.listOfSuppliers = [];
            // this.listOfSupplierBanks = [];
            this.NoSearchRecordFound = true

            this.selectedAccount = null;
            this.selectedSupplier = null;
            this.selectedSupplierBank = null;
            this.listOfAllocatedSites = [];
            this.listOfSupplierAllocatedSites = [];
            this.listOfSupplierBankAllocatedSites = [];

          } else {
            this.selectedAccount = null;
            this.selectedSupplier = null;
            this.selectedSupplierBank = null;

            this.listOfAccounts = [...response.result.operator];
            this.listOfSuppliers = [...response.result.supplier];
            this.listOfSupplierBanks = [...response.result.supplierBank];

            if (this.listOfAccounts?.length > 0) {
              this.isVisibleAccountFilter = true;
              if (Object.keys(this.selectedSiteDetails)?.length > 0 && !this.isSearch) {
                this.selectedAccount = this.selectedSiteDetails.AccountId;
                this.onSelectAccount(this.selectedAccount);
              } else {
                // this.selectedAccount = null;
                this.onSelectAccount();
              }
            } else {
              this.listOfAllocatedSites = [];
            }

            if (this.listOfSuppliers?.length > 0) {
              this.isVisibleSupplierFilter = true;
              if (Object.keys(this.selectedSiteDetails)?.length > 0 && !this.isSearch) {
                this.selectedSupplier = this.selectedSiteDetails.AccountId;
                this.onSelectSupplier(this.selectedSupplier);
              } else {
                // this.selectedSupplier = null;
                this.onSelectSupplier();
              }
            } else {
              this.listOfSupplierAllocatedSites = [];
            }

            if (this.listOfSupplierBanks?.length > 0) {
              this.isVisibleSupplierBankFilter = true;
              if (Object.keys(this.selectedSiteDetails)?.length > 0 && !this.isSearch) {
                this.selectedSupplierBank = this.selectedSiteDetails.AccountId;
                this.onSelectSupplierBank(this.selectedSupplierBank);
              } else {
                // this.selectedSupplierBank = null;
                this.onSelectSupplierBank();
              }
            } else {
              this.listOfSupplierBankAllocatedSites = [];
            }

            localStorage.setItem('AllocatedSites', JSON.stringify(response.result));
          }

          this.isDataLoaded = false;
        } else {
          this._cs.displayMessage(responseMessageStatus.error, response.message);
          this.isDataLoaded = false;
          this._cs.logOut();
        }
      });
    }
  }

  onSearch(event: any) {
    this.searchText = event
    this.selectedSupplierBank = null
    this.selectedSupplier = null
    this.selectedSupplier = null;
    if (this.searchText.length >= 3) {
      this.searchTextChanged.next(this.searchText);
      this.NoSearchRecordFound = false
    }

    if (this.searchText.length == 0) {
      this.getUserSites(true);
      this.NoSearchRecordFound = false
    }
  }


  getUserSites(isLoading: boolean = false, isSearch: boolean = false) {
    this.isDataLoaded = isLoading;

    this._iS.getUserAccountsSites(this.searchText).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        if (typeof (response.result) == 'string') {
          this.noAccountsAssigned = true
        } else {
          if (this.searchText?.length == 0) {
            this.listOfAllocatedSites = [];
            this.listOfSupplierAllocatedSites = [];
            this.listOfSupplierBankAllocatedSites = [];
          }
          this.listOfAccounts = [...response.result.operator];
          this.listOfSuppliers = [...response.result.supplier];
          this.listOfSupplierBanks = [...response.result.supplierBank];

          //fetch sites from all operator accounts
          this.listOfSites = this.listOfAccounts.flatMap((account: any) => account.sites || []);
          //fetch sites from all supplierBank accounts
          const supplierBankSites = this.listOfSupplierBanks.flatMap((account: any) => account.sites || []);
          //merge sites from operator accounts and supplierBank accounts
          this.listOfSBSites = supplierBankSites;


          localStorage.setItem('listOfAccounts', JSON.stringify(this.listOfAccounts?.length || 0));
          localStorage.setItem('listOfSuppliers', JSON.stringify(this.listOfSuppliers?.length || 0));
          localStorage.setItem('listOfSupplierBanks', JSON.stringify(this.listOfSupplierBanks?.length || 0));
          localStorage.setItem('listOfSites', JSON.stringify(this.listOfSites?.length || 0));
          localStorage.setItem('listOfSBSites', JSON.stringify(this.listOfSBSites?.length || 0));

          if (this.listOfAccounts?.length > 0) {
            this.isVisibleAccountFilter = true;
            if (Object.keys(this.selectedSiteDetails)?.length > 0 && this.isPresentInList('ACCOUNTS', this.selectedSiteDetails.AccountId)) {
              this.selectedAccount = this.selectedSiteDetails.AccountId;
              this.onSelectAccount(this.selectedAccount);
            }
            // else {
            //   this.onSelectAccount();
            // }
          }
          if (this.listOfSuppliers?.length > 0) {
            this.isVisibleSupplierFilter = true;
            if (Object.keys(this.selectedSiteDetails)?.length > 0 && this.isPresentInList('SUPPLIER', this.selectedSiteDetails.AccountId)) {
              this.selectedSupplier = this.selectedSiteDetails.AccountId;
              this.onSelectSupplier(this.selectedSupplier);
            }
            // else {
            //   this.onSelectSupplier();
            // }
          }
          if (this.listOfSupplierBanks?.length > 0) {
            this.isVisibleSupplierBankFilter = true;
            if (Object.keys(this.selectedSiteDetails)?.length > 0 && this.isPresentInList('SUPPLIERBANK', this.selectedSiteDetails.AccountId)) {
              this.selectedSupplierBank = this.selectedSiteDetails.AccountId;
              this.onSelectSupplierBank(this.selectedSupplierBank);
            }
            // else {
            //   this.onSelectSupplierBank();
            // }
          }

          localStorage.setItem('AllocatedSites', JSON.stringify(response.result));
        }
        this.isDataLoaded = false;

      } else {
        this._cs.displayMessage(responseMessageStatus.error, response.message);
        this.isDataLoaded = false;
        this._cs.logOut();
      }
    });
  }

  isPresentInList(listName: string, accountId: string) {
    if (listName == 'ACCOUNTS') {
      const accountIndex = this.listOfAccounts.findIndex(item => item.accountId === accountId)
      return accountIndex != -1 ? true : false;
    }

    if (listName == 'SUPPLIER') {
      const supplierIndex = this.listOfSuppliers.findIndex(item => item.accountId === accountId)
      return supplierIndex != -1 ? true : false;
    }

    if (listName == 'SUPPLIERBANK') {
      const supplierBankIndex = this.listOfSupplierBanks.findIndex(item => item.accountId === accountId)
      return supplierBankIndex != -1 ? true : false;
    }
  }

  onSelectAccount(event = null) {
    if (event && this.searchText?.length >= 3) {
      const matchedAccount = [
        ...(this.listOfAccounts.find((x: any) => x.accountId === event)?.sites || [])
      ];

      this.listOfAllocatedSites = matchedAccount
      // .filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );

      this.selectedAccount = event

      // this.selectedAccount = null;
    }
    else if (!event && this.searchText?.length >= 3) {
      const accountSitesData = [...this.listOfAccounts];
      this.listOfAllocatedSites = accountSitesData
        .flatMap((account: any) => account.sites || []) // Combine all sites into one array
      // .filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );

      // const matchedAccountName = accountSitesData
      //   .filter((account: any) =>
      //     (account.sites || []).some((site: any) =>
      //       site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      //     )
      //   )
      //   .map((account: any) => account.accountId);

      // this.selectedAccount = matchedAccountName[0];
    } else {
      this.selectedSupplier = null;
      this.selectedSupplierBank = null;
      this.listOfSupplierBankAllocatedSites = [];
      this.listOfSupplierAllocatedSites = [];
      this.selectedAccount = event;

      // this.listOfAllocatedSites = [];
      this.listOfAllocatedSites = this.listOfAccounts.find(
        (x: any) => x.accountId == event
      )?.sites;
      this.searchText = null;
    }
  }

  onSelectSupplier(event: any = null) {
    if (event && this.searchText?.length >= 3) {
      this.listOfSupplierAllocatedSites = [event];
      this.listOfSupplierAllocatedSites = this.listOfSupplierAllocatedSites
      // .filter((site: any) =>
      //   site.investorDisplayName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
    } else if (!event && this.searchText?.length >= 3) {
      const supplierSitesData = [...this.listOfSuppliers];
      this.listOfSupplierAllocatedSites = supplierSitesData // Combine all sites into one array
      // .filter((supplier: any) =>
      //   supplier.investorDisplayName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
    } else {

      this.selectedSupplierBank = null;
      this.selectedAccount = null;
      this.listOfSupplierBankAllocatedSites = [];
      this.listOfAllocatedSites = [];

      this.listOfSupplierAllocatedSites = [];
      this.listOfSupplierAllocatedSites = this.listOfSuppliers.filter(
        (x: any) => x.id == event
      );
      this.searchText = null;
    }
    // this.NoSearchRecordFound = false
  }

  onSelectSupplierBank(event: any = null) {
    if (event && this.searchText?.length >= 3) {
      const matchedSupplierBanks = this.listOfSupplierBanks.find(
        (x: any) => x.accountId == event
      )?.sites;

      this.listOfSupplierBankAllocatedSites = matchedSupplierBanks
      // .filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );

      // this.selectedSupplierBank = null
    } else if (!event && this.searchText?.length >= 3) {
      const supplierBankSitesData = [...this.listOfSupplierBanks];
      this.listOfSupplierBankAllocatedSites = supplierBankSitesData
        .flatMap((account: any) => account.sites || []) // Combine all sites into one array
      // .filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );

      // const matchedSupplierBankAccountName = supplierBankSitesData
      //   .filter((account: any) =>
      //     (account.sites || []).some((site: any) =>
      //       site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      //     )
      //   )
      //   .map((account: any) => account.accountId);

      // this.selectedSupplierBank = matchedSupplierBankAccountName[0];

    } else {
      this.selectedSupplier = null;
      this.selectedAccount = null;
      this.listOfSupplierAllocatedSites = [];
      this.listOfAllocatedSites = [];

      this.selectedSupplierBank = event;
      this.listOfSupplierBankAllocatedSites = this.listOfSupplierBanks.find(
        (x: any) => x.accountId == event
      )?.sites;

      this.searchText = null;
    }
  }

  /** Same sign-out as the in-site header: revoke server-side, then clear locally whatever happens. */
  signOut(): void {
    this._iS.logOut().subscribe({
      next: () => this._cs.logOut(),
      error: () => this._cs.logOut(),
    });
  }

  //close switch account modal
  handleCancel() {
    this.isVisibleSwitchAccountModal = false;
    this.hideSwitchAccountModal.emit(this.isVisibleSwitchAccountModal);
    this.location.back();
  }
  //navigate user to landing page once site is selected
  navigateToLandingPage(siteId: string) {
    const targetRoute: any = this._iS.getPermissionBasedLandingRoute(siteId);

    if (this.BearerToken) {
      if (sessionStorage.getItem('SiteDetails')) {
        const newTab = window.open(targetRoute, '_blank');
        // if (newTab) {
        //   // Clear session storage in the new tab
        //   newTab.onload = () => {
        //     newTab.sessionStorage.clear(); // Clear session storage in the new tab
        //   };
        // }
        this.handleCancel();
      } else {
        // this.canAccessSummary
        //   ? this._router.navigate([`paybev/${siteId}/summary`])
        //   : this._router.navigate([`paybev/${siteId}/my-profile`]);
        this._router.navigate([targetRoute]);
        localStorage.setItem('IsSiteSelected', JSON.stringify(true));
      }
    }
  }

  navigateToSupplierLandingPage(siteData: any) {
    const userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
    const woSpaceEmail = SsoHandoffService.encodeEmail(userInfo.email ?? '');

    this.canAccessSupplierSummary = this._iS.canAccessSupplierSummary().canViewSummary;

    const targetRoute: any = this.canAccessSupplierSummary
      ? `supplier/${siteData?.id}/summary`
      : `supplier/${siteData?.id}/my-profile`;

    const buildLink = (code: string) => `${supplierPortalURL.URL}${targetRoute
      }?t=${code}&e=${woSpaceEmail}&qbo=${siteData?.qboEntityId}&pt=${this.BearerToken}`;
    const onFailure = () => this._cs.displayMessage(responseMessageStatus.error, 'Could not open the supplier portal. Please try again.');

    // const linkToOpen = `http://localhost:4202/${targetRoute
    //   }?t=${woSpaceToken}&e=${woSpaceEmail}&qbo=${siteData?.qboSupplierId}&pt=${this.BearerToken}`;

    if (this.BearerToken) {
      if (sessionStorage.getItem('SiteDetails')) {
        this.ssoHandoff.openInNewTab('SUPPLIER', buildLink, onFailure);
        this.handleCancel();
      } else {
        localStorage.setItem('IsSiteSelected', JSON.stringify(true));
        this.ssoHandoff.navigate('SUPPLIER', buildLink, onFailure);
      }
    }
  }

  customFilterFn = (search: string, option: any): boolean => {
    const normalize = (str: string) =>
      str
        ?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // remove accents

    const searchValue = normalize(search);
    const optionLabel = normalize(option.nzLabel);

    return optionLabel.includes(searchValue);
  };

  //#endregion
}
